import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./Footer.css";
import ShareButton from "./ShareButton";

const Footer = () => {
  const { pathname } = useLocation();

  return (
    <footer className="footer">
      <div className="footer-content">
        <ShareButton className="footer-share-button" />
        <p className="footer-meta">
          © 2025 |
          <Link to="/terms" className={`footer-link${pathname === "/terms" ? " active" : ""}`}>
            {" "}Terms of Use
          </Link>{" "}|
          <Link to="/privacy" className={`footer-link${pathname === "/privacy" ? " active" : ""}`}>
            {" "}Privacy Policy
          </Link>{" "}|
          <Link to="/contact" className={`footer-link${pathname === "/contact" ? " active" : ""}`}>
            {" "}Contact
          </Link>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
